var Backbone, SupportOrderActionsTemplate, SupportOrderActionsView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderActionsTemplate = require('../../../order_actions.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderActionsView = (function(superClass) {
  extend(SupportOrderActionsView, superClass);

  function SupportOrderActionsView() {
    return SupportOrderActionsView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderActionsView.prototype.className = 'order-actions';

  SupportOrderActionsView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportOrderActionsTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportOrderActionsView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportOrderActionsView.prototype.toHash = function() {
    return {};
  };

  return SupportOrderActionsView;

})(Backbone.View);

module.exports = SupportOrderActionsView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9vcmRlcl9hY3Rpb25zX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9vcmRlcl9hY3Rpb25zX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsOERBQUE7RUFBQTs7O0FBQUEsMkJBQUEsR0FBOEIsT0FBQSxDQUFRLHNDQUFSOztBQUM5QixRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFFUDs7Ozs7OztvQ0FDSixTQUFBLEdBQVc7O29DQUVYLFVBQUEsR0FBWSxTQUFBO0lBQ1YsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7V0FDWixJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7RUFIZjs7b0NBS1osTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOztvQ0FHUixNQUFBLEdBQVEsU0FBQTtXQUNOO0VBRE07Ozs7R0FYNEIsUUFBUSxDQUFDOztBQWMvQyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
